import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import ChatSoundBanner from "@/components/ChatSoundBanner";
import { ChatCircleDots, Warning, MapPin, CalendarBlank } from "@phosphor-icons/react";

const SL = { menunggu: "Menunggu", siap_berangkat: "Siap Berangkat", dalam_perjalanan: "Dalam Perjalanan", tiba: "Sudah Tiba", selesai: "Layanan Selesai" };

export default function HomecareChatStaff() {
  const [rooms, setRooms] = useState([]);
  const nav = useNavigate();

  const load = useCallback(() => {
    api.get(`/homecare/rooms/mine`).then((r) => setRooms(r.data.rooms)).catch((e) => toast.error(apiError(e)));
  }, []);
  useEffect(() => { document.title = "Chat Homecare Saya — GBS"; load(); const id = setInterval(load, 10000); return () => clearInterval(id); }, [load]);

  const openR = [...rooms].sort((a, b) => (a.status === "open" ? -1 : 1) - (b.status === "open" ? -1 : 1));

  return (
    <div className="mx-auto max-w-md p-4" data-testid="homecare-staff">
      <div className="sticky top-0 z-20 -mx-4 mb-2 border-b border-purple-100 bg-white/95 px-4 py-2 backdrop-blur">
        <button data-testid="hc-staff-back-dashboard" onClick={() => nav("/jadwal")} className="inline-flex items-center gap-1 text-xs font-bold text-[#6A38C7] transition-transform active:scale-95">
          ← Kembali ke Dashboard
        </button>
      </div>
      <h1 className="mb-1 flex items-center gap-2 font-heading text-lg font-extrabold text-[#4C1D95]"><ChatCircleDots size={20} weight="duotone" className="text-[#DB2777]" /> Chat Homecare Saya</h1>
      <p className="mb-3 text-xs text-slate-400">Ruang chat untuk tugas homecare yang ditugaskan kepada Anda.</p>
      <ChatSoundBanner />
      {rooms.length === 0 && <p className="mt-2 rounded-xl border border-dashed border-pink-200 p-8 text-center text-sm text-slate-400" data-testid="hc-staff-empty">Belum ada ruang chat homecare untuk Anda.</p>}
      <div className="space-y-2">
        {openR.map((r) => (
          <button key={r.id} data-testid={`hc-staff-room-${r.id}`} onClick={() => nav(`/homecare-chat/${r.id}`)} className="w-full rounded-2xl border border-purple-100 bg-white p-3 text-left active:scale-[.99]">
            <div className="flex items-center justify-between">
              <p className="font-bold text-slate-700" data-testid={`hc-staff-client-${r.id}`}>{r.client_name}</p>
              <div className="flex items-center gap-1">
                {(r.unread || 0) > 0 && <span data-testid={`hc-staff-unread-${r.id}`} className="inline-flex min-w-[18px] items-center justify-center rounded-full bg-rose-500 px-1.5 py-0.5 text-[10px] font-bold text-white">{r.unread}</span>}
                {r.emergency?.active && <span className="flex items-center gap-1 rounded-full bg-[#DB2777] px-2 py-0.5 text-[10px] font-bold text-white"><Warning size={11} weight="fill" /> DARURAT</span>}
                <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${r.status === "open" ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>{r.status === "open" ? "Aktif" : "Ditutup"}</span>
              </div>
            </div>
            <p className="mt-0.5 text-xs text-slate-500">{r.service || "Layanan Homecare"}</p>
            <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-slate-500">
              <span className="inline-flex items-center gap-1"><CalendarBlank size={13} /> {r.tanggal_kunjungan || "-"} · {r.jam_kunjungan || "-"}</span>
              <span className="rounded-full bg-[#EEE6FF] px-2 py-0.5 font-bold text-[#6A38C7]">{SL[r.service_status] || "Menunggu"}</span>
              {r.location && <span className="inline-flex items-center gap-1 text-[#6A38C7]"><MapPin size={12} weight="fill" /> lokasi</span>}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
